/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PosApiModel } from './pos';
import { LoyaltyApiModel } from './loyalty';
import { CouponBatchApiModel } from './coupon-batch';

export interface NewsApiModel {
  /**
   * Category title
   */
  category_title?: string;
  coupon_batches?: Array<CouponBatchApiModel>;
  /**
   * News date
   */
  created?: string;
  /**
   * Description news
   */
  description?: string;
  /**
   * Extended description of news
   */
  description_extended?: string;
  /**
   * News ID
   */
  id?: string;
  /**
   * Url of news
   */
  link?: string;
  loyalty?: LoyaltyApiModel;
  /**
   * Url of news photo
   */
  photo?: string;
  pos?: PosApiModel;
  /**
   * News priority(0 - the greatest one)
   */
  priority?: number;
  /**
   * Record row offset
   */
  row_offset?: number;
  /**
   * Title of news
   */
  title?: string;
  /**
   * Type of news
   */
  type?: NewsApiModelTypeEnum;
}
export enum NewsApiModelTypeEnum {
  Text = 'text',
  Html = 'html',
  Link = 'link'
}
